import { useEffect, useState } from 'react';
import { Modal, Box, Text, PasswordInput, Flex, Button } from '@mantine/core';

export function SkipPasswordModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  onCancel,
  onCancelAll,
  fileName = '',
  withActions = true,
  submitLabel = 'Yes',
  cancelLabel = 'No',
  isSkipping,
  isDeletingAllProtectedFiles
}) {
  const [pwd, setPwd] = useState();

  const handleSubmit = e => {
    e.preventDefault();
    if (!pwd?.trim()) return;

    onConfirm(pwd);
  };

  useEffect(() => {
    setPwd('');

    return () => {
      setPwd('');
    };
  }, [fileName]);

  return (
    <Modal
      opened={isOpen}
      onClose={() => onClose()}
      title="Locked Files"
      centered
      withCloseButton={false}
    >
      <Box component="form" onSubmit={handleSubmit}>
        {title && (
          <Text
            fz="14px"
            mb="24px"
            lh="20px"
            c="#495057"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}

        <PasswordInput
          placeholder="Enter password"
          label={fileName}
          value={pwd}
          onChange={e => setPwd(e.target.value)}
        />

        {withActions && (
          <Flex align="center" mt="46px" justify="space-between">
            <Button
              size="xs"
              onClick={onCancelAll}
              variant="subtle"
              type="button"
              disabled={isDeletingAllProtectedFiles}
            >
              Cancel All
            </Button>

            <Flex align="center" gap="8px">
              <Button
                size="xs"
                onClick={onCancel}
                variant="outline"
                type="button"
                color="gray"
                disabled={isSkipping}
              >
                {cancelLabel}
              </Button>

              <Button
                size="xs"
                loading={isLoading}
                disabled={isLoading || !pwd}
                onClick={handleSubmit}
                type="submit"
              >
                {submitLabel}
              </Button>
            </Flex>
          </Flex>
        )}
      </Box>
    </Modal>
  );
}
